// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type EstateWaterfallInsurancePolicy_InsurancePolicyFragment = { __typename?: 'InsurancePolicy', id: string, deathBenefitAmount: CurrencyUSD, kind: Types.InsurancePolicyKind, carrierName?: string | null, startDate?: Time | null, termDurationYears?: number | null, cashValue?: CurrencyUSD | null, householdID: string, policyHolders?: Array<{ __typename?: 'ClientProfile', id: string }> | null };

export const Operations = {
  Fragment: {
    EstateWaterfallInsurancePolicy_InsurancePolicy: 'EstateWaterfallInsurancePolicy_InsurancePolicy' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateWaterfallInsurancePolicy_InsurancePolicyFragmentDoc = gql`
    fragment EstateWaterfallInsurancePolicy_InsurancePolicy on InsurancePolicy {
  id
  deathBenefitAmount
  policyHolders {
    id
  }
  kind
  carrierName
  startDate
  termDurationYears
  cashValue
  householdID
}
    `;